import { FC } from "react";
import { FormControl } from "@mui/material";
import { Box, styled } from "@mui/system";
import { H3, H5, Span } from "../Typography";

const StyledForm = styled("form")(() => ({
  width: "100%",
}));

const InputBox = styled(FormControl)(() => ({
  width: "100%",
  margin: "8px 0px",
}));

const styleObj = {
  margin: "10px 0px",
  width: "100%",
  padding: ".6rem .8rem",
  fontSize: ".9rem",
  borderRadius: "5px",
  lineHeight: "1.5",
  border: "none",
  transition: "all .3s",
};

const StyledInput = styled("input")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const StyledSelect = styled("select")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const Error = styled(Span)(({ theme }) => ({
  color: theme.palette.error.main,
}));

interface Props {
  handleClose?: any;
  setSuccessModal: (value: boolean) => void;
  register?: any;
  handleSubmit?: any;
  onSubmit?: any;
  errors?: any;
}
const ProfileEditForm: FC<Props> = (props) => {
  const { register, handleSubmit, onSubmit, errors } = props;

  return (
    <>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <InputBox>
          <H5>
            Name <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="MH Rafi"
            {...register("name", { required: true })}
          />
          {errors.name && <Error>Name is required</Error>}
        </InputBox>

        <InputBox>
          <H5>
            Email <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="uilib.example@gmail.com"
            {...register("email", { required: true })}
          />
          {errors.email && <Error>Email is required</Error>}
        </InputBox>

        <InputBox>
          <H5>Description</H5>
          <StyledInput {...register("description")} />
        </InputBox>

        <H3>Shipping Information</H3>
        <InputBox>
          <H5>
            Address line 1 <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="390, Street"
            {...register("address1", { required: true })}
          />
          {errors.address1 && <Error>Address line 1 is required</Error>}
        </InputBox>

        <InputBox>
          <H5>Address line 2</H5>
          <StyledInput {...register("address2")} />
        </InputBox>

        <InputBox>
          <H5>
            Town <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="Sylhet"
            {...register("town", { required: true })}
          />
          {errors.town && <Error>Town is required</Error>}
        </InputBox>

        <Box display="flex">
          <InputBox sx={{ mr: "10px" }}>
            <H5>
              State <Span color="red">*</Span>
            </H5>
            <StyledInput
              placeholder="State"
              {...register("state", { required: true })}
            />
            {errors.state && <Error>State is required</Error>}
          </InputBox>
          <InputBox sx={{ ml: "10px" }}>
            <H5>
              Post Code <Span color="red">*</Span>
            </H5>
            <StyledInput
              type="number"
              placeholder="Post code"
              {...register("postCode", { required: true })}
            />
            {errors.postCode && <Error>Post code is required</Error>}
          </InputBox>
        </Box>

        <InputBox>
          <H5>
            Country <Span color="red">*</Span>
          </H5>
          <StyledSelect {...register("postCode", { required: true })}>
            <option value="Select Country">Select Country</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="India">India</option>
            <option value="Pakistan">Pakistan</option>
          </StyledSelect>
          {errors.postCode && <Error>Country name is required</Error>}
        </InputBox>
      </StyledForm>
    </>
  );
};

export default ProfileEditForm;
